@if(!field()){
<code>Loading ...</code>
}
@else{
<mat-card appearance="outlined">
  <mat-card-header class="card-view-header">    
    <mat-card-title>{{field().displayName}}</mat-card-title>
    <button matButton="outlined" (click)="add()" [disabled]="editing || formControl.disabled">
      <mat-icon>add_circle</mat-icon> {{ 'buttons.add-new' | translate }}
    </button>
  </mat-card-header>
  <mat-card-content>
    @if(!entries || entries.length === 0){
    <div class="no-records">
      <code>{{ 'global.no-data' | translate }}</code>
    </div>
    }
  </mat-card-content>

  @for(entry of entries;track $index){
  <mat-card-content>
    <mat-card appearance="raised">
      <mat-card-content>
        @if(entry.mode === 'view'){
        <div class="card-view-container">
          @for(field of entry.fields;track $index){
          <div class="card-view-item" [class]="field.renderType.classes">
            <span class="item-label"><b>{{ getFieldLabel(field) }}</b>: </span>
            @if(field.renderType.element === 'date-picker'){
            <span class="item-value">{{field.value | date:'MMM dd, yyyy'}}</span>
            }
            @else{
            <span class="item-value">{{field.value}}</span>
            }
          </div>
          }
        </div>
        }
        @else{
        @if(formGroup){
        <form [formGroup]="formGroup" class="form-container">
          <div class="special-control-container">
            @for(field of entry.fields; track field)
            {
            <div class="special-control-item" [class]="field.renderType.classes">
              <ng-template appDynamicHost [field]="field" [control]="getFormControl(field)"></ng-template>
            </div>
            }
          </div>
        </form>
        }
        }
      </mat-card-content>
      <mat-card-actions>
        <hr />
        @if(entry.mode === 'view'){
        <button matButton (click)="edit(entry)" [disabled]="editing || formControl.disabled">{{ 'buttons.edit' | translate }}</button>
        <button matButton (click)="confirmAction('delete',entry)" [disabled]="editing || formControl.disabled">{{ 'buttons.delete' | translate }}</button>
        }
        @else{
        <button matButton (click)="cancel(entry)">{{ 'buttons.cancel' | translate }}</button>
        <button matButton (click)="confirmAction('save',entry)" [disabled]="!formGroup?.dirty||false">{{ 'buttons.save' | translate }}</button>
        }
      </mat-card-actions>
    </mat-card>

  </mat-card-content>

  }
</mat-card>
}


